/**
 * Dashboard URL Configuration
 * Automatically switches between development and production
 */

const DASHBOARD_URL_DEV = "http://localhost:3333";
const DASHBOARD_URL_PROD = "https://app.dlweb.co";

/**
 * Get dashboard URL for client-side requests
 * @returns Dashboard URL based on environment
 */
export function getDashboardUrl(): string {
  // Check if running in browser
  if (typeof window !== "undefined") {
    // Production: any hostname that is NOT localhost
    const isProduction = !window.location.hostname.includes("localhost");
    return isProduction ? DASHBOARD_URL_PROD : DASHBOARD_URL_DEV;
  }
  
  // Fallback for SSR
  return process.env.NODE_ENV === "production" 
    ? DASHBOARD_URL_PROD 
    : DASHBOARD_URL_DEV;
}

/**
 * Get dashboard URL for server-side requests
 * @returns Dashboard URL based on environment
 */
export function getDashboardUrlServer(): string {
  return process.env.NODE_ENV === "production" 
    ? DASHBOARD_URL_PROD 
    : DASHBOARD_URL_DEV;
}

